import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../Common/TextInput';
import { useAccounts } from '../../DataStore/AccountsContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useSchool } from '../../DataStore/SchoolContext';
import CallOut from '../Common/CallOut';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    voteName: '',
    cashAccount: '',
    incomeAccount: '',
    loading: false,
}


const NewFeesVote = () => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {setSystemFunction} = useTheme();
     const {
            getIncomeAccounts,
            accountsReceivableListing,
            incomeAccountListing,
            getAccountsReceivable,
        } = useAccounts();

    const {getFeesVotes} = useSchool();

    useEffect(()=>{
        getIncomeAccounts();
        getAccountsReceivable();
    }, [])

    useEffect(()=>{
        setSystemFunction(() => handleSave);
        return () => setSystemFunction(() => {});
    }, [state]);


    const handleSave=async()=>{
        setInfo('');
        if(state.voteName.length > 0 && state.cashAccount.value && state.incomeAccount.value)
        {   
            setInfo(<ActivityLoader/>)
            const server_response = await ajaxSchool.createFeesVote(state.voteName, state.incomeAccount.value, state.cashAccount.value);
            if(server_response.status==="OK"){
                dispatch({type: 'voteName', value: ''})
                setInfo(<Notification type="success" message={server_response.message} closable={false}/>)
                getFeesVotes(true)
            }else{
                setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
            }

        }else{
            setInfo(<Notification type="danger" message="Complete all vote fields and try again." closable={false}/>)
        }
    }



    const RenderIncomeAccount = () => {

        const options=[];
        if(Array.isArray(incomeAccountListing))
        {
            incomeAccountListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }

        return(
            <TextInput
                type="select"
                label="Income Category"
                placeholder={state.incomeAccount.label || "Select income account..."}
                leftIcon="fa fa-university"
                options={options}
                onChange={item => dispatch({type: 'incomeAccount', value: item})}
                leftComponent={<i className="fa fa-university link" onClick={()=>getIncomeAccounts(true)}></i>}
                loading={!incomeAccountListing}
                required
                wrap
                value={state.incomeAccount}
            />
        )
    };

    const RenderCashAccount = () => {

        const options=[];
        if(Array.isArray(accountsReceivableListing))
        {
            accountsReceivableListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }

        return(
            <TextInput
                type="select"
                label="Accounts Receivable"
                placeholder={state.cashAccount.label || "Select Accounts Receivable..."}
                leftIcon="fa fa-university"
                options={options}
                onChange={item => dispatch({type: 'cashAccount', value: item})}
                leftComponent={<i className="fa fa-university link" onClick={()=>getAccountsReceivable(true)}></i>}
                loading={!accountsReceivableListing}
                required
                wrap
                value={state.cashAccount}
            />
        )
    };


    return (
        <>
        <CallOut
            title="Fees Votes"
            description="A fees vote represents a specific charge such as tuition, meals, transport, or activities. Votes are used to structure billing and track payments accurately."
            />

        <div className='mt-4'>{info}</div>
        <form method='post' onSubmit={handleSave}>
                <TextInput
                    type="text"
                    label="Vote Name"
                    placeholder="Enter Vote Name"
                    leftIcon="fa fa-tag"
                    onChange={e => dispatch({type: 'voteName', value: e.target.value})}
                    required
                    value={state.voteName}
                    wrap
                    />
        
                 {RenderIncomeAccount()}
                 {RenderCashAccount()}

        </form>
        </>
    );
};

export default NewFeesVote;